import React from "react";
import MediaDetailsCard from "./MediaDetailsCard";

const AdUnitDetailsCard = ({
  orgMedia,
  assignedAdGroupUnit,
  selectedAdUnits = [],
  handleDeleteMedias = () => {},
}) => {
  return (
    <MediaDetailsCard
      orgMedia={orgMedia}
      assignedAdGroupUnit={assignedAdGroupUnit}
      selectedAdUnits={selectedAdUnits}
      handleDeleteMedias={handleDeleteMedias}
      isVideo={false}
    />
  );
};

export default AdUnitDetailsCard;
